import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'

import ReferralOrdersTable from './partials/ReferralOrdersTable'

import { handleError, parsePagination } from '../../helpers'
import { getReferralOrders } from './services'

export default function ReferralOrdersList() {
	const { user } = useSelector(state => state.auth)
	const [referralOrders, setReferralOrders] = useState(null)
	const [filterType, setFilterType] = useState('referral.employee.document')
	const [filterValue, setFilterValue] = useState('')
	const [filterScope, setFilterScope] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const history = useHistory()

	useEffect(() => {
		!referralOrders && getReferralOrders({
			...pagination,
			'filter[referral.employee_id]': user.id,
			[`filter[${filterType}]`]: filterValue,
			[filterScope ? `filter[${filterScope}]` : 'noscope']: 1,
			include: 'incentive,referral.employee'
		})
			.then(res => {
				setReferralOrders(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ referralOrders, pagination, filterType, filterValue, filterScope, user ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Listado de incentivos enviados"
				subtitle="Listado de todos los incentivos enviados a referidos"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				filterScope={filterScope}
				setFilterScope={setFilterScope}
				reload={() => setReferralOrders(null)}
				options={[
					{ label: 'Buscar por nombre de incentivo', value: 'incentive.name' },
					{ label: 'Buscar por nombre del referido', value: 'referral.name' },
					{ label: 'Buscar por documento del referido', value: 'referral.document' },
				]}
				scopes={[
					{ label: 'Solicitudes pendientes', value: 'pendding' },
					{ label: 'Solicitudes completadas', value: 'completed' },
					{ label: 'Solicitudes vencidas', value: 'expired' },
					{ label: 'Solicitudes anuladas', value: 'voided' },
				]}
				ctaText="Enviar incentivo a referido"
				handleCtaClick={() => history.push('/referral_orders/new')}
			/>
			<Card>
				<CardBody>
					<ReferralOrdersTable 
						referralOrders={referralOrders}
						reload={() => setReferralOrders(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
		</React.Fragment>
	)
}